import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { AppMainComponent } from '../../../../../app.main.component';
import { AccountModuleId, LeadModuleId } from '../../../constants/modules.constant';
import { Status } from '../../../models/status';
import { AddEditAddressModalService } from './address-add-update-modal.service';
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { addInList } from '../../../helpers';
import { AppMainService } from '../../../../../app-main.service';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { AccountsHttpService } from '../../../services/accounts.http.service';

@Component({
    selector: 'app-lion-add-edit-address-modal',
    templateUrl: './address-add-update-modal.component.html',
    styleUrls: ['./address-add-update-modal.component.scss'],
    providers: [ConfirmationService]
})
export class LionAddEditAddressModalComponent implements OnChanges, OnInit {
    accountAddressTypeList = [];
    contactListAttn = [];
    selectedAddressType;
    prevAddressType;
    selectedAddressClass;
    displayAddAddrType: boolean = false;
    showPlaceElm: boolean = false;
    sameAsBilling: boolean = false;
    isShowShipping = false;
    @Input() addressName: string='';
    @Input() moduleId;
    @Input() currentAllowEditValue;

    accountModuleId = AccountModuleId;
    leadModuleId = LeadModuleId;

    constructor(
        public app: AppMainComponent,
        private addEditAddressModalService: AddEditAddressModalService,
        public confirmationService: ConfirmationService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private storeService: StoreService,
        private accountsHttpService: AccountsHttpService,
    ) { }

    defaultAddresObj = {
        id: 0,
        createdSource: this.app.user.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        addressId: 0,
        address: {
            id: 0,
            attnContact: null,
            attnContactId: 0,
            streetAddress1: '',
            streetAddress2: '',
            createdSource: null,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            addressType: null,
            name: "",
            description: '',
            latitude: null,
            longitude: null,
            country: null,
            state: null,
            city: null,
            cityId: 0,
            stateId: 0,
            countryId: 0,
            zipCode: "",
            addressTypeId: 0,
            statusId: Status.InActive,
            updatedBy: null,
            updatedDate: null,
            updatedSource: null,
            isDefault: false,
        },
        updatedBy: null,
        updatedDate: null,
        updatedSource: null
    };

    selectedAddressCountry = null;
    selectedAddressState = null;
    selectedAddressCity = null;
    selectedAddressattnContact = null;
    addressTemp = null;
    addressTypes = [];
    countryList = [];
    stateList = [];
    cityList = [];
    formattedaddress = '';
    hasBilling = false;

    currentHeader = '';
    currentLabels = [];
    displayAddressAdd
    isAddAddressMode: boolean;
    currentSelectedObjectRecord = null;
    currentEditAddressIndex = -1;
    currentMappingField = '';

    @Input() currentAddressList;
    @Input() addressHeader: string;
    @Input() display: boolean;
    @Input() fieldLabels = [];
    @Input() addressObject = null;
    @Input() isAddAddress: boolean;
    @Input() addressObj: any = null;
    @Input() contactListAttnList = [];
    @Input() selectedObjectRecord = null;
    @Input() editAddressIndex = null;
    @Input() mappingField: string;
    @Input() countries = [];
    @Input() accountAddressTypes = [];
    @Input() addressClasses = [];
    @Input() checkedFields;
    @Input() overViewPage: boolean = false;
    @Output() onCancelAddAddress = new EventEmitter();
    @Output() onAddAddress = new EventEmitter();
    @Output() onUpdateAddressList = new EventEmitter();

    @ViewChild('addAdddressFrm') addAdddressFrm: FormGroupDirective;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentAddressList && changes.currentAddressList.currentValue) {
            this.currentAddressList = changes.currentAddressList.currentValue
        }

        if (changes.addressHeader && changes.addressHeader.currentValue) {
            this.currentHeader = changes.addressHeader.currentValue
        }

        if (changes.display && changes.display.currentValue != undefined) {
            this.displayAddressAdd = changes.display.currentValue;
        }

        if (changes.fieldLabels && changes.fieldLabels.currentValue) {
            this.currentLabels = changes.fieldLabels.currentValue;
        }

        if (changes.isAddAddress && changes.isAddAddress.currentValue != undefined) {
            this.isAddAddressMode = changes.isAddAddress.currentValue.id ? true : false;
        }

        if (changes.addressObj && changes.addressObj.currentValue) {
            this.addressTemp = changes.addressObj.currentValue;
            this.setEditAddressDetails();
        } else {
            this.addressTemp = JSON.parse(JSON.stringify(this.defaultAddresObj));
        }

        if (changes.contactListAttnList && changes.contactListAttnList.currentValue) {
            this.contactListAttn = changes.contactListAttnList.currentValue;
        }

        if (changes.selectedObjectRecord && changes.selectedObjectRecord.currentValue) {
            this.currentSelectedObjectRecord = changes.selectedObjectRecord.currentValue;
        }

        if (changes.editAddressIndex && changes.editAddressIndex.currentValue != null) {
            this.currentEditAddressIndex = changes.editAddressIndex.currentValue;
        }

        if (changes.mappingField && changes.mappingField.currentValue) {
            this.currentMappingField = changes.mappingField.currentValue;
        }

        if (changes.accountAddressTypes && changes.accountAddressTypes.currentValue) {
            this.addressTypes = changes.accountAddressTypes.currentValue;
            this.populateAddressTypes();
        }

        if (changes.addressClasses && changes.addressClasses.currentValue) {
            this.addressClasses = changes.addressClasses.currentValue;
            this.populateAddressClasses();
        }

        if (changes.overViewPage && changes.overViewPage.currentValue) {
            this.overViewPage = changes.overViewPage.currentValue;
        }

        setTimeout(() => {
            this.populateAddressTypes();
            this.populateAddressClasses();
        }, 100);
    }

    ngOnInit(): void {
    }

    populateAddressTypes() {
        const foundAddressType = this.addressTypes.find((ele) => ele.id == this.addressTemp.address.addressTypeId);

        this.selectedAddressType = foundAddressType || this.addressTypes.filter(el => el.isDefault)[0];

        if (this.addressHeader !== 'Edit Address' && this.selectedAddressType?.name === 'Billing') {
            this.isShowShipping = true;
        } else {
            this.isShowShipping = false;
        }
    }

    populateAddressClasses() {
        const foundAddressClass = this.addressClasses?.find((ele) => ele?.id == this.addressTemp?.address?.addressClassId);
        this.selectedAddressClass = foundAddressClass || this.addressClasses?.filter(el => el?.isDefault)[0];
    }

    getDefaultAddressObj() {
        this.defaultAddresObj[this.currentMappingField] = 0
    }

    mapToAccountAddAddress(addressObj){
        const addRess = {
            id: addressObj?.id || 0,
            createdSource: addressObj.createdSource || this.app.userIP,
            createdBy: addressObj.createdBy || this.app.user.userId,
            createdDate: addressObj.createdDate || new Date(),
            accountId:   this.currentSelectedObjectRecord?.id || 0,
            addressId: addressObj.address?.id || 0, // need to change
            address: {
              id: addressObj.address?.id || 0,
              attnContactId: addressObj.address?.attnContactId || null,
              streetAddress1: addressObj.address?.streetAddress1 || '',
              streetAddress2: addressObj.address?.streetAddress2 || '',
              createdSource: addressObj.address?.createdSource || this.app.userIP,
              createdBy: addressObj.address?.createdBy || this.app.user.userId,
              createdDate: addressObj.address?.createdDate || new Date(),
              name:
                addressObj.address.addressType &&
                addressObj.address.addressType.name
                  ? addressObj.address.addressType.name
                  : addressObj.address?.name,
              description: addressObj.address?.description || '',
              latitude: addressObj.address?.latitude || null,
              longitude: addressObj.address?.longitude || null,
              cityId: addressObj.address?.city?.id || null,
              stateId: addressObj.address?.state?.id || null,
              countryId: addressObj.address?.country?.id || null,
              zipCode: addressObj.address?.zipCode || '',
              addressTypeId:
                addressObj.address?.addressType?.id ||
                addressObj.address?.addressTypeId,
              addressClassId:
                addressObj.address?.addressClass?.id ||
                addressObj.address?.addressClassId,
              addressName: addressObj.address.addressName || null,
              customAttributeValues:
                addressObj.address.customAttributeValues &&
                addressObj.address.customAttributeValues.length > 0
                  ? addressObj.address.customAttributeValues
                  : null,
              statusId:
                addressObj.address && addressObj.address.statusId
                  ? addressObj.address.statusId
                  : 2,
              updatedBy: addressObj.address?.updatedBy || null,
              updatedDate: addressObj.address?.updatedDate || null,
              updatedSource: addressObj.address?.updatedSource || null,
              isDefault: addressObj.address?.isDefault || false,
            },
            updatedBy: addressObj.updatedBy || null,
            updatedDate: addressObj.updatedDate || null,
            updatedSource: addressObj.updatedSource || null,
        }
        return addRess;
    }

    mapToAddressObject(addressObj) {
        let moduleIdField = this.currentMappingField;

        const mappedAddressObj = {
            id: addressObj.id || 0,
            createdSource: addressObj.createdSource || this.app.userIP,
            createdBy: addressObj.createdBy || this.app.user.userId,
            createdDate: addressObj.createdDate || new Date(),
            addressId: addressObj.address?.id || 0, // need to change
            address: {
                id: addressObj.address?.id || 0,
                attnContact: addressObj.address?.attnContact || null,
                attnContactId: addressObj.address?.attnContact?.contactId || null,
                streetAddress1: addressObj.address?.streetAddress1 || '',
                streetAddress2: addressObj.address?.streetAddress2 || '',
                createdSource: addressObj.address?.createdSource || this.app.userIP,
                createdBy: addressObj.address?.createdBy || this.app.user.userId,
                createdDate: addressObj.address?.createdDate || new Date(),
                addressType: addressObj.address?.addressType || null,
                addressClass: addressObj.address?.addressClass || null,
                addressClassId: addressObj.address?.addressClassId || null,
                addressName: addressObj.address.addressName || null,
                name: addressObj.address.addressType && addressObj.address.addressType.name ? addressObj.address.addressType.name : addressObj.address?.name,
                description: addressObj.address?.description || "",
                latitude: addressObj.address?.latitude || null,
                longitude: addressObj.address?.longitude || null,
                city: addressObj.address?.city || null,
                cityId: addressObj.address?.city?.id || null,
                state: addressObj.address?.state || null,
                stateId: addressObj.address?.state?.id || null,
                country: addressObj.address?.country || null,
                countryId: addressObj.address?.country?.id || null,
                zipCode: addressObj.address?.zipCode || "",
                addressTypeId: addressObj.address?.addressType.id || 0, // need to change
                customAttributeValues: addressObj.address.customAttributeValues && addressObj.address.customAttributeValues.length > 0 ? addressObj.address.customAttributeValues : null,
                status: addressObj.address && addressObj.address.statusId ? addressObj.address.statusId == true ? { id: 1, name: "Active" } : { id: 2, name: "InActive" } : { id: 2, name: "InActive" },
                statusId: (addressObj.address && addressObj.address.statusId == true) ? true : (addressObj.address && addressObj.address.statusId == false) ? false : !addressObj ? 3 : addressObj.address.statusId,
                updatedBy: addressObj.address?.updatedBy || null,
                updatedDate: addressObj.address?.updatedDate || null,
                updatedSource: addressObj.address?.updatedSource || null,
                isDefault: addressObj.address?.isDefault || false,
            },
            updatedBy: addressObj.updatedBy || null,
            updatedDate: addressObj.updatedDate || null,
            updatedSource: addressObj.updatedSource || null,
        }

        mappedAddressObj[moduleIdField] = this.currentSelectedObjectRecord ? this.currentSelectedObjectRecord.id : 0;
        return mappedAddressObj;
    }

    async setEditAddressDetails() {
        this.prevAddressType = this.selectedAddressType = this.addressTypes.find(
            (ele) => ele.id == this.addressTemp.address.addressTypeId
        );
        this.selectedAddressClass = this.addressClasses.find(
            (ele) => ele.id == this.addressTemp.address.addressClassId
        );
        this.selectedAddressCountry = this.countries.find(c => c.id == this.addressTemp?.address?.country?.id);
        await this.loadCountryStates();
        this.selectedAddressState = this.addressTemp.address.state;
        await this.loadCountryCities();
        this.selectedAddressCity = this.addressTemp.address.city;
        this.displayAddressAdd = true;
        this.selectedAddressattnContact = this.contactListAttn.find((ob: any) => this.addressTemp && this.addressTemp.address.attnContactId && ob.contactId == this.addressTemp.address.attnContactId)
    }

    getStates(country) {
        if (country && country.id) {
            return this.addEditAddressModalService.getAllStates(country.id);
        } else { return []; }
    }

    async loadCountryStates() {
        this.stateList = await this.getStates(this.selectedAddressCountry);
    }

    async loadCountryCities() {
        this.cityList = await this.getCities(this.selectedAddressState);
    }

    getCities(state) {
        if (state && state.id) {
            return this.addEditAddressModalService.getAllCities(state.id);
        } else { return []; }
    }

    getAddressObj(address) {
        const addressObj = {
            street_number: null,
            subpremise: null,
            plus_code: null,
            neighborhood: null,
            landmark: null,
            route: null,
            sublocality_level_3: null,
            sublocality_level_2: null,
            sublocality_level_1: null,
            locality: null,
            city: null,
            state: null,
            country: null,
            zipCode: null,
            latitude: address.geometry.location.lat(),
            longitude: address.geometry.location.lng(),
        }
        address.address_components.forEach(comp => {
            const field = comp.types[0];
            if (field == 'street_number') {
                addressObj.street_number = comp;
            }
            if (field == 'plus_code') {
                addressObj.plus_code = comp;
            }
            if (field == 'neighborhood') {
                addressObj.neighborhood = comp;
            }
            if (field == 'landmark') {
                addressObj.landmark = comp;
            }
            if (field == 'route') {
                addressObj.route = comp;
            }
            if (field == 'sublocality_level_3') {
                addressObj.sublocality_level_3 = comp;
            }
            if (field == 'sublocality_level_2') {
                addressObj.sublocality_level_2 = comp;
            }
            if (field == 'sublocality_level_1') {
                addressObj.sublocality_level_1 = comp;
            }
            if (field == 'subpremise') {
                addressObj.subpremise = comp;
            }
            // city
            if (field == 'locality') {
                addressObj.locality = comp;
                addressObj.city = comp;
            }
            // // city
            // if(field =='administrative_area_level_2'){
            //     addressObj.city = comp;
            // }
            // state
            if (field == 'administrative_area_level_1') {
                addressObj.state = comp;
            }

            if (field == 'country') {
                addressObj.country = comp;
            }
            if (field == 'postal_code') {
                addressObj.zipCode = comp;
            }
        });
        if (addressObj.city == null) {
            addressObj.city = addressObj.sublocality_level_1;
        }
        return addressObj;
    }

    getStreetAddres(googleAddressObj) {
        const street = [];
        if (googleAddressObj.plus_code) {
            street.push(googleAddressObj.plus_code.long_name);
        }
        if (googleAddressObj.street_number) {
            street.push(googleAddressObj.street_number.long_name);
        }
        if (googleAddressObj.route) {
            street.push(googleAddressObj.route.long_name);
        }
        if (googleAddressObj.subpremise) {
            street.push(`#${googleAddressObj.subpremise.long_name}`);
        }
        if (googleAddressObj.neighborhood) {
            street.push(googleAddressObj.neighborhood.long_name);
        }
        if (googleAddressObj.sublocality_level_3) {
            street.push(googleAddressObj.sublocality_level_3.long_name);
        }
        if (googleAddressObj.sublocality_level_2) {
            street.push(googleAddressObj.sublocality_level_2.long_name);
        }
        if (googleAddressObj.sublocality_level_1 && googleAddressObj.locality != null) {
            street.push(googleAddressObj.sublocality_level_1.long_name);
        }
        // if(googleAddressObj.locality){
        //     street.push(googleAddressObj.locality.long_name);
        // }
        return street.length ? street.join(' ') : '';
    }

    async onAddressChanged(address: any) {
        this.onRemoveAddressLocation(address);
        this.formattedaddress = address.formatted_address;
        const googleAddressObj = this.getAddressObj(address);
        setTimeout(() => {
            const da = this.getStreetAddres(googleAddressObj); //updatedAddressLine;
            this.addressTemp.address.streetAddress1 = da
            this.formattedaddress = da;
        })
        this.addressTemp.address.latitude = googleAddressObj.latitude;
        this.addressTemp.address.longitude = googleAddressObj.longitude;;

        let searchedCountry = googleAddressObj.country ? googleAddressObj.country.long_name : '';
        let searchedZipcode = googleAddressObj.zipCode ? googleAddressObj.zipCode.long_name : '';
        let searchedState = googleAddressObj.state ? googleAddressObj.state.long_name : '';
        let searchedCity = googleAddressObj.city ? googleAddressObj.city.long_name : '';
        if (searchedCountry) {
            let matchedCountry;
            if (searchedCountry == 'USA' || searchedCountry == 'United States') {
                matchedCountry = this.countries.find(obj => obj.name == searchedCountry || obj.countryCode == googleAddressObj.country.short_name);
            } else {
                matchedCountry = this.countries.find(obj => obj.name == searchedCountry)
            }

            this.selectedAddressCountry = matchedCountry;
            //set zipcode
            if (searchedZipcode) {
                this.addressTemp.address.zipCode = searchedZipcode;
            }

            if (matchedCountry) {
                this.appMainService.isShowSpinner('loadStates')
                this.stateList = await this.getStates(matchedCountry)||[];
                this.appMainService.isHideSpinner('loadStates')

                if (searchedState) {
                    //set state
                    let matchedState = this.stateList.find(obj => obj.name == searchedState || obj.shortName == googleAddressObj.state.short_name);
                    if (!matchedState) {
                        // add state
                        matchedState = await this.addState(googleAddressObj.state, matchedCountry.id);
                    }
                    this.appMainService.isShowSpinner('loadCity')
                    this.cityList = await this.getCities(matchedState);
                    this.appMainService.isHideSpinner('loadCity')
                    this.selectedAddressState = matchedState;

                    if (searchedCity) {
                        //set city
                        let matchedCity = this.cityList ? this.cityList.find(obj => obj.name == searchedCity) : null;
                        if (!matchedCity) {
                            matchedCity = await this.addCity(searchedCity, matchedState.id);
                        }
                        this.selectedAddressCity = matchedCity;
                    }
                }
            }
        }
    }

    async addCity(searchedCityName, stateId) {
        const data = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": null,
            "createdBy": this.app.user.userId,
            "updatedBy": 0,
            "createdDate": new Date(),
            "updatedDate": null,
            "name": searchedCityName,
            "description": searchedCityName,
            "stateId": stateId,
            "statusId": Status.Active,
        }
        this.appMainService.isShowSpinner('addNewCity');
        const newAddedCity = await this.addEditAddressModalService.addCity(data)
        this.cityList = addInList(this.cityList, newAddedCity);
        this.appMainService.isHideSpinner('addNewCity');
        return newAddedCity;
    }

    async addState(stateDetails, countryId) {
        const data = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": null,
            "createdBy": this.app.user.userId,
            "updatedBy": 0,
            "createdDate": new Date(),
            "updatedDate": null,
            "name": stateDetails.long_name,
            "shortName": stateDetails.short_name,
            "description": stateDetails.long_name,
            "countryId": countryId,
            "statusId": Status.Active,
        }
        this.appMainService.isShowSpinner('addNewState');
        const newAddedState = await this.addEditAddressModalService.addState(data);
        this.stateList = addInList(this.stateList, newAddedState);
        this.appMainService.isHideSpinner('addNewState');
        return newAddedState;
    }

    onRemoveAddressLocation(event) {
        this.addressTemp.address.streetAddress1 = '';
        this.selectedAddressCountry = null;
        this.selectedAddressState = null;
        this.selectedAddressCity = null;
        this.addressTemp.address.streetAddress1 = '';
    }

    onAddressBlur(address) {
        this.addressTemp.address.streetAddress1 = address;
        if (address == '') {
            this.addressTemp.address.streetAddress1 = '';
            this.selectedAddressCountry = null;
            this.selectedAddressState = null;
            this.selectedAddressCity = null;
            this.addressTemp.address.streetAddress1 = '';
        }
    }

    getAddrType(e) {
        const typeName = this.prevAddressType ? this.prevAddressType.name : null;

        if (typeName === 'Billing' && this.addressHeader === 'Edit Address') {
            const isDefault = this.addressObj?.address?.isDefault;

            if (isDefault) {
                setTimeout(() => {
                    this.prevAddressType = this.selectedAddressType = this.addressTypes.find(el => el.name === 'Billing');
                }, 100);

                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Can not change default billing address type ...'
                });

                return;
            }
        }

        this.prevAddressType = this.selectedAddressType = e.value;

        const { name } = this.selectedAddressType;

        if (name === 'Billing') {
            if (this.addressHeader !== 'Edit Address') {
                this.isShowShipping = true;
            }
        } else {
            this.sameAsBilling = false;
            this.isShowShipping = false;
        }
    }

    deleteAddress(c) {
        this.confirmationService.confirm({
            message: 'Do you want to delete this Addresss?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                // let typeCount = 0;
                // const currentAddress = this.currentAddressList[this.currentEditAddressIndex];

                // for (const el of this.currentAddressList) {
                //     if (el?.address?.addressType?.name === currentAddress?.address?.addressType?.name) {
                //         ++typeCount;
                //     }
                // }

                // if (typeCount === 1) {
                //     this.messageService.add({
                //         severity: 'warn',
                //         summary: 'Warning',
                //         detail: `Can not delete only ${currentAddress?.address?.addressType?.name} address...`
                //     });
                //     return;
                // }

                if((this.currentAddressList.length-1) >= this.currentEditAddressIndex && this.currentAddressList[this.currentEditAddressIndex]?.address){
                    this.currentAddressList[this.currentEditAddressIndex].address.statusId = 3;
                    this.currentAddressList[this.currentEditAddressIndex].address.isDefault = false;
                    const deletedAddress = this.currentAddressList[this.currentEditAddressIndex];

                    for (let el of this.currentAddressList) {
                        if (el.address.addressType.name === deletedAddress.address.addressType.name &&
                            el.address.statusId !== 3) {
                            el.address.statusId = 1;
                            el.address.isDefault = true;
                            break;
                        }
                    }
                }
                if(this.overViewPage){
                    this.deleteAccountAddress(this.addressTemp?.id);
                }
                this.onUpdateAddressList.emit({ addressList: this.currentAddressList });
                this.resetForm();
                this.displayAddressAdd = false;
            }
        });
    }

    addToAddressList() {
        this.addressTemp.address = {
            ...this.addressTemp.address,
            country: this.selectedAddressCountry,
            state: this.selectedAddressState,
            city: this.selectedAddressCity,
            addressType: this.selectedAddressType,
            addressClass: this.selectedAddressClass,
            addressClassId: this.selectedAddressClass.id,
            attnContactId: this.selectedAddressattnContact?.contactId||null,
            attnContact: this.selectedAddressattnContact,
            addressName: this.addressName
        }

        const addressObj = this.mapToAddressObject(this.addressTemp);
        const addressObj2 = this.mapToAccountAddAddress(this.addressTemp);
        const checkedDefault = this.currentAddressList.find(el=> el.address.addressType.name === this.addressTemp.address.addressType?.name && el.address.statusId !== 3 && el.address.isDefault);

        if(!checkedDefault){
            addressObj.address.isDefault = true;
            addressObj.address.statusId = 1;
            addressObj2.address.isDefault = true;
            addressObj2.address.statusId = 1;
        }else if(checkedDefault?.id!=this.addressTemp?.id){
            addressObj.address.isDefault = false;
            addressObj2.address.isDefault = false;
        }

        if (addressObj.address.statusId === true) {
            addressObj.address.statusId = 1;
            addressObj2.address.statusId = 1;
        }
        if(this.overViewPage){
            if(this.currentHeader === 'Edit Address'){
                this.editAccountAddress(addressObj2,addressObj);
            }else{
                this.addAccountAddress(addressObj2,addressObj,false);
            }
        }else{
            this.onAddAddress.emit({ address: addressObj });
        }

        if (this.addressHeader === 'Edit Address') {
            this.isShowShipping = false;
            this.resetForm();
            return;
        }

        const hasBilling = this.currentAddressList.find(el => el.address.addressType.name === 'Billing' && el.address.statusId !== 3);

        if (!hasBilling && addressObj?.address?.addressType?.name !== 'Billing') {
            this.addAsBilling();
            this.resetForm();
        }

        if (!this.sameAsBilling) {
            this.resetForm();
        }

        // for (let s of this.currentAddressList) {
        //     if (s.address.addressType.name == 'Billing') {
        //         this.hasBilling = true;
        //         break;
        //     } else {
        //         this.hasBilling = false;
        //     }
        // }

        // if (this.hasBilling && this.addressTemp.address.addressType.name == 'Billing') {
        //     this.repeatBilling = true;
        // } else {
        //     this.onAddAddress.emit({ address: addressObj });
        //     this.hasBilling = false;
        // }

        if (this.sameAsBilling) {
            if (this.addressTemp.address.addressType.name == 'Billing') {
                this.addAsShipping();
                this.resetForm();
            } else if (this.addressTemp.address.addressType.name == 'Shipping') {
                const billingAddress = this.addressTypes.find(el => el.name === 'Billing');
                const shippingAddress = this.addressTypes.find(el => el.name === 'Shipping');
                this.addressTemp = {
                    ...this.addressTemp,
                    address: {
                        ...billingAddress,
                        addressType: shippingAddress,
                        addressTypeId: shippingAddress?.id,
                        addressClass: this.selectedAddressClass,
                        addressClassId: this.selectedAddressClass.id
                    }
                }
                this.addAsShipping();
                this.resetForm();
            }
        }

        this.isShowShipping = false;
    }

    addAccountAddress(data,addressObj,shippingSameAsBilling: boolean){
        this.appMainService.isShowSpinner('addAddress');
        this.accountsHttpService.addAccountAddress(data).subscribe({
            next:(response)=>{
                addressObj.id = response?.id;
                addressObj.address.id = response?.address?.id;
                addressObj.addressId = response?.addressId;
                this.onAddAddress.emit({ address: addressObj });
                if(shippingSameAsBilling){
                }else{
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address is successfully added...' });
                }
                this.appMainService.isHideSpinner('addAddress');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('addAddress');
            },
        })
    }

    editAccountAddress(data,addressObj){
        this.appMainService.isShowSpinner('updateAddress');
        this.accountsHttpService.editAccountAddress(data).subscribe({
            next:(data)=>{
                // this.getAccountAddress(data,addressObj);
                this.onAddAddress.emit({ address: addressObj });
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address is successfully updated...' });
                this.appMainService.isHideSpinner('updateAddress');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('updateAddress');
            },
        })
    }

    deleteAccountAddress(id){
        this.appMainService.isShowSpinner('deleteAddress');
        this.accountsHttpService.deleteAccountAddress(id).subscribe({
            next:(data)=>{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address is successfully deleted...' });
                this.appMainService.isHideSpinner('deleteAddress');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('deleteAddress');
            },
        })
    }

    getAccountAddress(data,addressObj){
        this.appMainService.isShowSpinner('getAccountAddress');
        this.accountsHttpService.getAccountAddress(addressObj?.accountId).subscribe({
            next:(data)=>{
                // this.onAddAddress.emit({ address: addressObj });
                // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address is successfully updated...' });
                this.appMainService.isHideSpinner('getAccountAddress');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getAccountAddress');
            },
        })
    }

    addAsBilling() {
        const billingAddressType = this.addressTypes?.find(el => el.name === 'Billing');

        let billingAddress = {
            ...this.addressTemp,
            address: {
                ...this.addressTemp?.address,
                addressType: billingAddressType,
                addressTypeId: billingAddressType?.id,
                addressClass: this.selectedAddressClass,
                addressClassId: this.selectedAddressClass?.id,
                country: this.selectedAddressCountry,
                state: this.selectedAddressState,
                city: this.selectedAddressCity,
                attnContact: this.selectedAddressattnContact,
            }
        }

        const addressObj = this.mapToAddressObject(billingAddress);
        const addressObj2 = this.mapToAccountAddAddress(billingAddress);
        let isFirst = true;

        for (let el of this.currentAddressList) {
            if (el.address.addressType.name === 'Billing' && el.address.statusId !== 3) {
                isFirst = false;
            }
        }

        if (isFirst) {
            addressObj.address.isDefault = true;
            addressObj.address.statusId = 1;
            addressObj2.address.isDefault = true;
            addressObj2.address.statusId = 1;
        }

        if (addressObj.address.statusId === true) {
            addressObj.address.statusId = 1;
            addressObj2.address.statusId = 1;
        }

        if (this.overViewPage) {
            addressObj2.address.attnContactId = billingAddress?.address?.attnContact?.contactId;
            this.addAccountAddress(addressObj2, addressObj,true);
        } else {
            this.onAddAddress.emit({ address: addressObj });
        }
    }

    addAsShipping() {
        const shippingAddressType = this.addressTypes?.find(el => el.name === 'Shipping');

        let shippingAddress = {
            ...this.addressTemp,
            address: {
                ...this.addressTemp?.address,
                addressType: shippingAddressType,
                addressTypeId: shippingAddressType?.id,
                addressClass: this.selectedAddressClass,
                addressClassId: this.selectedAddressClass?.id,
                country: this.selectedAddressCountry,
                state: this.selectedAddressState,
                city: this.selectedAddressCity,
                attnContact: this.selectedAddressattnContact,
            }
        }

        const addressObj = this.mapToAddressObject(shippingAddress);
        const addressObj2 = this.mapToAccountAddAddress(shippingAddress);

        let isFirst = true;

        for (let el of this.currentAddressList) {
            if (el.address.addressType.name === 'Shipping' && el.address.statusId !== 3) {
                isFirst = false;
            }
        }

        if (isFirst) {
            addressObj.address.isDefault = true;
            addressObj.address.statusId = 1;
            addressObj2.address.isDefault = true;
            addressObj2.address.statusId = 1;
        }

        if (addressObj.address.statusId === true) {
            addressObj.address.statusId = 1;
            addressObj2.address.statusId = 1;
        }
        if (this.overViewPage) {
            addressObj2.address.attnContactId = shippingAddress?.address?.attnContact?.contactId;
            this.addAccountAddress(addressObj2, addressObj, true);
        } else {
            this.onAddAddress.emit({ address: addressObj });
        }
    }

    cancelAddAddress() {
        this.onCancelAddAddress.emit({ addressTemp: this.addressTemp });
        this.isShowShipping = false;
        this.resetForm();
    }

    resetForm() {
        this.addAdddressFrm.form.reset();
        this.addressTemp = JSON.parse(JSON.stringify(this.defaultAddresObj))
    }

    onSaveAddressType($event) {
        const addTypes = this.addressTypes;
        addTypes.splice(addTypes.length - 1, 0, $event.addressType);
        this.addressTypes = JSON.parse(JSON.stringify(addTypes));
        this.displayAddAddrType = false;
    }

    cancelAddAddressType($event) {
        this.displayAddAddrType = false;
    }
}
